module.exports = __webpack_public_path__ + "static/media/phila_light.02e92d2a.webp";